import { Component, OnInit } from '@angular/core';
import { Usuario } from '../shared/index';
import { CertificadoService } from '../shared/service/certificado/certificado.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { UtilService } from '../shared/service/util/util.service';
import { TourInterativo } from '../shared/Tour/TourInterativo';
import { TourService } from 'ngx-tour-ngx-popper';
import { TourState } from 'ngx-tour-core';
import { UsuarioService } from '../shared/service/usuario/usuario.service';

declare var $: any;

@Component({
  selector: 'app-fatores-autenticacao',
  templateUrl: './fatores-autenticacao.component.html',
  styleUrls: ['./fatores-autenticacao.component.css']
})
export class FatoresAutenticacaoComponent implements OnInit {

  public usuario: Usuario;
  public confirm: string;
  public regex: string = "";
  public descricaoRegex: string = "";
  public statusFatores: any = {};
  public novoCodigoChave: string;
  public acao: string = "solicitar";
  public acessaTour: boolean = false;
  public showSpinner: boolean = false;

  constructor(
    private certificadoService: CertificadoService,
    private usuarioService: UsuarioService,
    private route: ActivatedRoute,
    public tourService: TourService,
    private tourInterativo: TourInterativo,
    private utilService: UtilService) {
  }

  ngOnInit() {
    this.showSpinner = true;
    this.usuario = JSON.parse(localStorage.getItem("currentUser"));
    let politicaSenha = this.route.snapshot.data['obterPoliticaSenha'];

    if (politicaSenha != null) {
      this.regex = politicaSenha.regex;
      this.descricaoRegex = politicaSenha.descricao;
    }

    if ((localStorage.getItem('isVarejo') == "true"))
      this.acao = "emitir";

    this.verificaTour();
    this.buscaStatusFatores();
  }

  buscaStatusFatores() {
    let idUsuario = this.usuario.id;
    let idOrganizacao = this.usuario.organizacaoId;

    this.certificadoService.getStatusFatores(idUsuario, idOrganizacao).subscribe(
      res => {
        this.statusFatores = res;
        this.showSpinner = false;
      }
    );
  }

  resetTour(finalizarTour?: boolean) {
    if (finalizarTour) {
      this.tourService.end();
    }
  }

  eTokenCadastrado() {
    this.buscaStatusFatores();
    this.acessaTour = false;
  }

  iniciarTour() {
    if (this.tourService.steps.length == 0 || (this.statusFatores.usuarioCadastrouPin &&
      (this.statusFatores.tokenOtpObrigatorio && this.statusFatores.usuarioCadastrouTokenOtp))) {
      this.tourInterativo.getPassosTour();
    }

    if (this.tourService.getStatus() == TourState.ON) {
      this.tourService.goto(this.tourService.currentStep.stepId);
    } else {
      this.tourService.start();
    }
  }

  verificaTour() {
    if (this.tourService.steps.length == 0) {
      this.tourInterativo.getPassosTour();
    }

    if (this.tourService.steps[0] != null
      && this.tourService.steps[0].stepId == "stepId.Autenticacao") {
      this.acessaTour = true;
    }
  }

  recebeMensagemSucesso(mensagem) {
    this.utilService.showSuccess(mensagem);
  }

  recebeNovoCodigoChave(codigoChave) {
    this.statusFatores.modoRecuperacaoPin = "C";
    this.novoCodigoChave = codigoChave;
    $('#modalExibirCodigoChave').modal('show');
  }
}
